// extracted by mini-css-extract-plugin
export default {"container":"_1UOG6","time":"WcVLH","title":"XxZnU","chevron":"hJJUC"};